import script from "./AccountList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountList.vue?vue&type=script&setup=true&lang=ts"

import "./AccountList.vue?vue&type=style&index=0&id=4dd28db2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd28db2"]])

export default __exports__